(() => {
  /**
   * Keeps the "Our Price" value in cue collection listings synchronised with the
   * currently selected variant while preserving the theme's locale-aware number
   * formatting (for example, 1,299.00). It also appends formatted price
   * differences to variant dropdown options so shoppers understand how each
   * choice affects the final price.
   */
  function initDynamicVariantPriceFormatting() {
    let productList = document.querySelectorAll('.bottom_meucci ul li');

    if (productList === null || productList.length === 0) {
      productList = document.querySelectorAll('.miscellaneous_prod ul li');
    }

    if (productList === null || productList.length === 0) {
      return;
    }

    productList.forEach((productCard) => {
      const dropdownSelector = productCard.querySelector('.miscellaneous_select');
      if (dropdownSelector === null) {
        return;
      }

      const variantList = dropdownSelector.querySelectorAll('option');
      if (variantList === null || variantList.length === 0) {
        return;
      }

      const productPriceElement = productCard.querySelector('.mutable-product-price');
      if (productPriceElement === null) {
        return;
      }

      appendPriceDiffToDropdownOptions();
      changePriceOnVariantSelect();

      function formatPrice(priceInCents) {
        const cents = parseInt(priceInCents, 10);
        if (Number.isNaN(cents)) {
          return '';
        }

        if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
          return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
        }

        return `$${(cents / 100).toFixed(2)}`;
      }

      function appendPriceDiffToDropdownOptions() {
        variantList.forEach((variantOption) => {
          const variantPrice = parseInt(variantOption.dataset.variantPrice, 10);
          if (Number.isNaN(variantPrice)) {
            return;
          }

          const lowestProductPrice = parseInt(dropdownSelector.dataset.lowestProductPrice, 10);
          const priceDifference = variantPrice - (Number.isNaN(lowestProductPrice) ? 0 : lowestProductPrice);
          const baseLabel = variantOption.dataset.baseLabel || variantOption.textContent;
          variantOption.dataset.baseLabel = baseLabel;

          if (priceDifference > 0) {
            const formattedDifference = formatPrice(priceDifference);
            if (formattedDifference) {
              variantOption.textContent = `${baseLabel} +${formattedDifference}`;
            }
            return;
          }

          variantOption.textContent = baseLabel;
        });
      }

      function changePriceOnVariantSelect() {
        dropdownSelector.addEventListener('change', (dropdownEl) => {
          const selectedVariant = dropdownEl.target.selectedOptions[0];
          if (!selectedVariant) {
            return;
          }

          const selectedVariantPrice = parseInt(selectedVariant.dataset.variantPrice, 10);
          if (Number.isNaN(selectedVariantPrice)) {
            return;
          }

          const formattedPrice = formatPrice(selectedVariantPrice);
          if (formattedPrice) {
            productPriceElement.innerHTML = `${formattedPrice}`;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDynamicVariantPriceFormatting);
  } else {
    initDynamicVariantPriceFormatting();
  }
})();
